import { render } from "./ProduSpecif.vue?vue&type=template&id=41f3e354&scoped=true"
import script from "./ProduSpecif.vue?vue&type=script&lang=js"
export * from "./ProduSpecif.vue?vue&type=script&lang=js"

import "./ProduSpecif.vue?vue&type=style&index=0&id=41f3e354&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-41f3e354"

export default script